import smallDog from '@assets/images/order-form-price-info-small.svg';
import middleDog from '@assets/images/order-form-price-info-middle.svg';
import bigDog from '@assets/images/order-form-price-info-big.svg';



const PriceInfo = (): JSX.Element => {

	return (
		<div className='price-info-section'>

			<div className='info-text'>Orientačně se cena VETlímce pohybuje následovně:</div>

			<div className='info-item small-size'>
				<p>Malý pes</p>
				<p>od 1250 Kč s DPH</p>
				<img src={smallDog} alt='price-info-small-dog-image' />
			</div>

			<div className='info-item middle-size'>
				<p>Střední pes</p>
				<p>od 1400 Kč s DPH</p>
				<img src={middleDog} alt='price-info-middle-dog-image' />
			</div>

			<div className='info-item big-size'>
				<p>Velký pes</p>
				<p>od 1700 Kč s DPH</p>
				<img src={bigDog} alt='price-info-big-dog-image' />
			</div>

		</div>
	);
};

export default PriceInfo;